import type { Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function Popover(theme: Theme) {
  return {
    MuiPopover: {
      styleOverrides: {
        paper: {
          borderRadius: Number(theme.shape.borderRadius) * 1.5,
        },
      },
    },
  };
}
